export default __webpack_public_path__ + "static/media/6_bronty_no_bg.9e1d8393.png";